import {
    ApiHandler,
    createHandlerChainRunner,
    HasOnSuccess,
    HasOnError,
} from "@insite/client-framework/HandlerCreator";
import {
    updateProductType,
    AddOrUpdateProductTypeApiModel,
    ProductTypeModel,
} from "@tCentro/Services/CENAdminProductTypeService";

export interface UpdateProductTypeParameter extends HasOnSuccess<ProductTypeModel>, HasOnError<string> {
    model: AddOrUpdateProductTypeApiModel;
}

type HandlerType = ApiHandler<UpdateProductTypeParameter, { apiResult: ProductTypeModel }>;

export const UpdateProductType: HandlerType = async props => {
    try {
        const result = await updateProductType(props.parameter.model);
        if (props.parameter.onSuccess) {
            props.parameter.onSuccess(result as ProductTypeModel);
        }
    } catch (error: any) {
        if (props.parameter.onError) {
            props.parameter.onError(error?.message ?? "Failed to update product type");
        }
    }
};

export const chain = [UpdateProductType];
const updateProductTypeData = createHandlerChainRunner(chain, "updateProductTypeData");
export default updateProductTypeData;
